<style scoped>
  .openapp {
    position: relative;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
  }
  .openapp-img {
    position: absolute;
    right: 10px;
    top: 0;
    width: 78vw;
    height: 33vw;
    background-image: url(../assets/images/wx-masks.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    z-index: 22;
  }
</style>

<template>
  <div class="openapp" :class="isWx ? 'xmask' : ''">
    <div class="openapp-img"></div>
  </div>
</template>

<script>
export default {
  name: 'openApp',
  data () {
    return {
      isWx: false
    }
  },
  created() {
    const typeObj = navigator.userAgent;
    this.isWx = typeObj.toLowerCase().indexOf('micromessenger') !== -1;
    console.log(this.isWx,'isWx');
    if (!this.isWx) {
      const isAndroid = typeObj.indexOf('Android') > -1 || typeObj.indexOf('Adr') > -1; //android终端
      const isIos = !!typeObj.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let path = isIos ? 'itms-apps://itunes.apple.com/cn/app/id1039256109' : 'gkapp://main:28080/mainactivity';
      window.location.href = path
      console.log(path,'path');
      setTimeout(() => {
        window.location.href = 'http://studio.gkgzj.com/download/deyagk.html'
      }, 3000)
    }
  }
};
</script>